
export default {
  methods: {
    gotoSpecifications() {
      // scroll down to the faq accordion panel and open the first one
      const firstAccordionItem = document.querySelector('.tlm-accordion .v-expansion-panel-header')
      if (firstAccordionItem) {
        const isClosed = !firstAccordionItem.classList.contains('v-expansion-panel-header--active')
        if (isClosed) {
          firstAccordionItem.click()
        }
        window.scroll({
          top: firstAccordionItem.getBoundingClientRect().top + window.scrollY,
          behavior: 'smooth'
        });
      }
    }
  }
}
